/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 848:
/***/ (function(module) {

/**
 * Get an array of an HTML elements classes
 * @param {HTMLElement} element
 * @returns {string[]} string array of class names
 */
var getClasses = function getClasses(element) {
  // Return without error if element or class are missing
  if (!element) return [];
  return element.className.split(' ').filter(Boolean);
};

/**
 * Does a class exist on an element
 * @param {HTMLElement} element
 * @returns {Boolean} true if element has class
 */
var hasClass = function hasClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return false;
  return getClasses(element).includes(className);
};

/**
 * Remove a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var removeClass = function removeClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return;
  if (hasClass(element, className)) {
    // Array of all existing classes
    var existingClasses = getClasses(element);
    // String of existing classes minus the class to remove
    var newClasses = existingClasses.filter(function (existingClass) {
      return existingClass !== className;
    }).join(' ');
    // Set class attribute to the new classes
    element.setAttribute('class', newClasses);
  }
};

/**
 * Add a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var addClass = function addClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return;
  if (!hasClass(element, className)) {
    // Set class attribute to the new classes
    element.setAttribute('class', (element.className + " " + className).trim());
  }
};

/**
 * Toggle a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var toggleClass = function toggleClass(element, className) {
  if (!element || !className) return;
  if (hasClass(element, className)) {
    removeClass(element, className);
  } else {
    addClass(element, className);
  }
};

/**
 * Toggle a boolean attribute on a HTML element
 * @param {HTMLElement} element
 * @param {string} attr
 */
var toggleAttribute = function toggleAttribute(element, attr) {
  // Return without error if element or attr are missing
  if (!element || !attr) return;
  // Toggle attribute value. Treat no existing attr same as when set to false
  var value = element.getAttribute(attr) === 'true' ? 'false' : 'true';
  element.setAttribute(attr, value);
};

/**
 * Toggle a toggle a class on conditional content for an input based on checked state
 * @param {HTMLElement} input input element
 * @param {string} className class to toggle
 */
var toggleConditionalInput = function toggleConditionalInput(input, className) {
  // Return without error if input or class are missing
  if (!input || !className) return;
  // If the input has conditional content it had a data-aria-controls attribute
  var conditionalId = input.getAttribute('aria-controls');
  if (conditionalId) {
    // Get the conditional element from the input data-aria-controls attribute
    var conditionalElement = document.getElementById(conditionalId);
    if (conditionalElement) {
      if (input.checked) {
        conditionalElement.classList.remove(className);
      } else {
        conditionalElement.classList.add(className);
      }
    }
  }
};

/**
 * Move focus to element
 *
 * Sets tabindex to -1 to make the element programmatically focusable,
 * but removes it on blur as the element doesn't need to be focused again.
 *
 * Original code taken from GDS (Government Digital Service)
 * {@link https://github.com/alphagov/govuk-frontend}
 *
 * @template {HTMLElement} FocusElement
 * @param {FocusElement} $element - HTML element
 * @param {object} [options] - Handler options
 * @param {function(this: FocusElement): void} [options.onBeforeFocus] - Callback before focus
 * @param {function(this: FocusElement): void} [options.onBlur] - Callback on blur
 */
function setFocus($element, options) {
  if (options === void 0) {
    options = {};
  }
  var isFocusable = $element.getAttribute('tabindex');
  if (!isFocusable) {
    $element.setAttribute('tabindex', '-1');
  }

  /**
   * Handle element focus
   */
  function onFocus() {
    $element.removeEventListener('focus', onFocus);
    $element.addEventListener('blur', onBlur);
  }

  /**
   * Handle element blur
   */
  function onBlur() {
    $element.removeEventListener('blur', onBlur);
    if (options.onBlur) {
      options.onBlur.call($element);
    }
    if (!isFocusable) {
      $element.removeAttribute('tabindex');
    }
  }

  // Add listener to reset element on blur, after focus
  $element.addEventListener('focus', onFocus);

  // Focus element
  if (options.onBeforeFocus) {
    options.onBeforeFocus.call($element);
  }
  $element.focus();
}
module.exports = {
  toggleClass: toggleClass,
  toggleAttribute: toggleAttribute,
  toggleConditionalInput: toggleConditionalInput,
  setFocus: setFocus
};

/***/ }),

/***/ 997:
/***/ (function(module) {

var CharacterCount = /*#__PURE__*/function () {
  function CharacterCount($module) {
    this.$module = $module;
    this.$textarea = $module.querySelector('.hse-js-character-count');
    this.$visibleCountMessage = null;
    this.$screenReaderCountMessage = null;
    this.lastInputTimestamp = null;
  }

  // Initialize component
  var _proto = CharacterCount.prototype;
  _proto.init = function init() {
    // Check that required elements are present
    if (!this.$textarea) {
      return;
    }

    // Check for module
    var $module = this.$module;
    var $textarea = this.$textarea;
    var $fallbackLimitMessage = document.getElementById($textarea.id + "-info");

    // Move the fallback count message to be immediately after the textarea
    // Kept for backwards compatibility
    $textarea.insertAdjacentElement('afterend', $fallbackLimitMessage);

    // Create the *screen reader* specific live-updating counter
    // This doesn't need any styling classes, as it is never visible
    var $screenReaderCountMessage = document.createElement('div');
    $screenReaderCountMessage.className = 'hse-character-count__sr-status hse-u-visually-hidden';
    $screenReaderCountMessage.setAttribute('aria-live', 'polite');
    this.$screenReaderCountMessage = $screenReaderCountMessage;
    $fallbackLimitMessage.insertAdjacentElement('afterend', $screenReaderCountMessage);

    // Create our live-updating counter element, copying the classes from the
    // fallback element for backwards compatibility as these may have been configured
    var $visibleCountMessage = document.createElement('div');
    $visibleCountMessage.className = $fallbackLimitMessage.className;
    $visibleCountMessage.classList.add('hse-character-count__status');
    $visibleCountMessage.setAttribute('aria-hidden', 'true');
    this.$visibleCountMessage = $visibleCountMessage;
    $fallbackLimitMessage.insertAdjacentElement('afterend', $visibleCountMessage);

    // Hide the fallback limit message
    $fallbackLimitMessage.classList.add('hse-u-visually-hidden');

    // Read options set using dataset ('data-' values)
    this.options = CharacterCount.getDataset($module);

    // Determine the limit attribute (characters or words)
    var countAttribute = this.defaults.characterCountAttribute;
    if (this.options.maxwords) {
      countAttribute = this.defaults.wordCountAttribute;
    }

    // Save the element limit
    this.maxLength = $module.getAttribute(countAttribute);

    // Check for limit
    if (!this.maxLength) {
      return;
    }

    // Remove hard limit if set
    $textarea.removeAttribute('maxlength');
    this.bindChangeEvents();

    // When the page is restored after navigating 'back' in some browsers the
    // state of the character count is not restored until *after* the DOMContentLoaded
    // event is fired, so we need to manually update it after the pageshow event
    // in browsers that support it.
    if ('onpageshow' in window) {
      window.addEventListener('pageshow', this.updateCountMessage.bind(this));
    } else {
      window.addEventListener('DOMContentLoaded', this.updateCountMessage.bind(this));
    }
    this.updateCountMessage();
  }

  // Read data attributes
;
  CharacterCount.getDataset = function getDataset(element) {
    var dataset = {};
    var attributes = element.attributes;
    if (attributes) {
      for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        var match = attribute.name.match(/^data-(.+)/);
        if (match) {
          dataset[match[1]] = attribute.value;
        }
      }
    }
    return dataset;
  }

  // Counts characters or words in text
;
  _proto.count = function count(text) {
    var length;
    if (this.options.maxwords) {
      var tokens = text.match(/\S+/g) || []; // Matches consecutive non-whitespace chars
      length = tokens.length; // eslint-disable-line prefer-destructuring
    } else {
      length = text.length; // eslint-disable-line prefer-destructuring
    }
    return length;
  }

  // Bind input propertychange to the elements and update based on the change
;
  _proto.bindChangeEvents = function bindChangeEvents() {
    var $textarea = this.$textarea;
    $textarea.addEventListener('keyup', this.handleKeyUp.bind(this));

    // Bind focus/blur events to start/stop polling
    $textarea.addEventListener('focus', this.handleFocus.bind(this));
    $textarea.addEventListener('blur', this.handleBlur.bind(this));
  }

  // Speech recognition software such as Dragon NaturallySpeaking will modify the
  // fields by directly changing its `value`. These changes don't trigger events
  // in JavaScript, so we need to poll to handle when and if they occur.
;
  _proto.checkIfValueChanged = function checkIfValueChanged() {
    if (!this.$textarea.oldValue) {
      this.$textarea.oldValue = '';
    }
    if (this.$textarea.value !== this.$textarea.oldValue) {
      this.$textarea.oldValue = this.$textarea.value;
      this.updateCountMessage();
    }
  }

  // Helper function to update both the visible and screen reader-specific
  // counters simultaneously (e.g. on init)
;
  _proto.updateCountMessage = function updateCountMessage() {
    this.updateVisibleCountMessage();
    this.updateScreenReaderCountMessage();
  }

  // Update visible counter
;
  _proto.updateVisibleCountMessage = function updateVisibleCountMessage() {
    var $textarea = this.$textarea;
    var $visibleCountMessage = this.$visibleCountMessage;
    var remainingNumber = this.maxLength - this.count($textarea.value);

    // If input is over the threshold, remove the disabled class which renders the
    // counter invisible.
    if (this.isOverThreshold()) {
      $visibleCountMessage.classList.remove('hse-character-count__message--disabled');
    } else {
      $visibleCountMessage.classList.add('hse-character-count__message--disabled');
    }

    // Update styles
    if (remainingNumber < 0) {
      $textarea.classList.add('hse-textarea--error');
      $visibleCountMessage.classList.remove('hse-hint');
      $visibleCountMessage.classList.add('hse-error-message');
    } else {
      $textarea.classList.remove('hse-textarea--error');
      $visibleCountMessage.classList.remove('hse-error-message');
      $visibleCountMessage.classList.add('hse-hint');
    }

    // Update message
    $visibleCountMessage.innerHTML = this.formattedUpdateMessage();
  }

  // Update screen reader-specific counter
;
  _proto.updateScreenReaderCountMessage = function updateScreenReaderCountMessage() {
    var $screenReaderCountMessage = this.$screenReaderCountMessage;

    // If over the threshold, remove the aria-hidden attribute, allowing screen
    // readers to announce the content of the element.
    if (this.isOverThreshold()) {
      $screenReaderCountMessage.removeAttribute('aria-hidden');
    } else {
      $screenReaderCountMessage.setAttribute('aria-hidden', true);
    }

    // Update message
    $screenReaderCountMessage.innerHTML = this.formattedUpdateMessage();
  }

  // Format update message
;
  _proto.formattedUpdateMessage = function formattedUpdateMessage() {
    var $textarea = this.$textarea;
    var options = this.options;
    var remainingNumber = this.maxLength - this.count($textarea.value);
    var charVerb = 'remaining';
    var charNoun = 'character';
    var displayNumber = remainingNumber;
    if (options.maxwords) {
      charNoun = 'word';
    }
    charNoun += remainingNumber === -1 || remainingNumber === 1 ? '' : 's';
    charVerb = remainingNumber < 0 ? 'too many' : 'remaining';
    displayNumber = Math.abs(remainingNumber);
    return "You have " + displayNumber + " " + charNoun + " " + charVerb;
  }

  // Checks whether the value is over the configured threshold for the input.
  // If there is no configured threshold, it is set to 0 and this function will
  // always return true.
;
  _proto.isOverThreshold = function isOverThreshold() {
    var $textarea = this.$textarea;
    var options = this.options;

    // Determine the remaining number of characters/words
    var currentLength = this.count($textarea.value);
    var maxLength = this.maxLength;

    // Set threshold if presented in options
    var thresholdPercent = options.threshold ? options.threshold : 0;
    var thresholdValue = maxLength * thresholdPercent / 100;
    return thresholdValue <= currentLength;
  }

  // Update the visible character counter and keep track of when the last update
  // happened for each keypress
;
  _proto.handleKeyUp = function handleKeyUp() {
    this.updateVisibleCountMessage();
    this.lastInputTimestamp = Date.now();
  };
  _proto.handleFocus = function handleFocus() {
    var _this = this;
    // If the field is focused, and a keyup event hasn't been detected for at
    // least 1000 ms (1 second), then run the manual change check.
    // This is so that the update triggered by the manual comparison doesn't
    // conflict with debounced KeyboardEvent updates.
    this.valueChecker = setInterval(function () {
      if (!_this.lastInputTimestamp || Date.now() - 500 >= _this.lastInputTimestamp) {
        _this.checkIfValueChanged();
      }
    }, 1000);
  };
  _proto.handleBlur = function handleBlur() {
    // Cancel value checking on blur
    clearInterval(this.valueChecker);
  };
  return CharacterCount;
}();
CharacterCount.prototype.defaults = {
  characterCountAttribute: 'data-maxlength',
  wordCountAttribute: 'data-maxwords'
};
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var characterCounts = scope.querySelectorAll('[data-module="hse-character-count"]');
  characterCounts.forEach(function (el) {
    new CharacterCount(el).init();
  });
};

/***/ }),

/***/ 305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleConditionalInput = _require.toggleConditionalInput;

/**
 * Conditionally show content when a checkbox button is checked
 * Test at http://localhost:3001/hse-frontend/components/checkboxes/conditional.html
 */
var syncAllConditionalReveals = function syncAllConditionalReveals(input) {
  var allInputsInForm = input.form.querySelectorAll('input[type="checkbox"]');
  allInputsInForm.forEach(function (item) {
    return toggleConditionalInput(item, 'hse-checkboxes__conditional--hidden');
  });
};

/**
 * Uncheck other checkboxes
 *
 * Find any other checkbox inputs with the checkbox group value, and uncheck them.
 * This is useful for when a “None of these" checkbox is checked.
 */
var unCheckAllInputsExcept = function unCheckAllInputsExcept(input) {
  var allInputsInSameExclusiveGroup = input.form.querySelectorAll("input[type=\"checkbox\"][data-checkbox-exclusive-group=\"" + input.getAttribute('data-checkbox-exclusive-group') + "\"]");
  allInputsInSameExclusiveGroup.forEach(function (inputWithSameName) {
    var hasSameFormOwner = input.form === inputWithSameName.form;
    if (hasSameFormOwner && inputWithSameName !== input) {
      inputWithSameName.checked = false; // eslint-disable-line no-param-reassign
    }
  });
  syncAllConditionalReveals(input);
};

/**
 * Uncheck exclusive inputs
 *
 * Find any checkbox inputs with the same checkbox group value and the 'exclusive' behaviour,
 * and uncheck them. This helps prevent someone checking both a regular checkbox and a
 * "None of these" checkbox in the same fieldset.
 */
var unCheckExclusiveInputs = function unCheckExclusiveInputs(input) {
  var allExclusiveInputsInSameExclusiveGroup = input.form.querySelectorAll("input[type=\"checkbox\"][data-checkbox-exclusive][data-checkbox-exclusive-group=\"" + input.getAttribute('data-checkbox-exclusive-group') + "\"]");
  allExclusiveInputsInSameExclusiveGroup.forEach(function (exclusiveInput) {
    var hasSameFormOwner = input.form === exclusiveInput.form;
    if (hasSameFormOwner) {
      exclusiveInput.checked = false; // eslint-disable-line no-param-reassign
    }
  });
  syncAllConditionalReveals(input);
};
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Checkbox input DOMElements inside a conditional form group
  var checkboxInputs = scope.querySelectorAll('.hse-checkboxes .hse-checkboxes__input');

  /**
   * Toggle classes and attributes
   * @param {Object} event click event object
   */
  var handleClick = function handleClick(event) {
    // Toggle conditional content based on checked state
    toggleConditionalInput(event.target, 'hse-checkboxes__conditional--hidden');
    if (!event.target.checked) {
      return;
    }

    // Handle 'exclusive' checkbox behaviour (ie "None of these")
    if (event.target.hasAttribute('data-checkbox-exclusive')) {
      unCheckAllInputsExcept(event.target);
    } else {
      unCheckExclusiveInputs(event.target);
    }
  };

  // When the page is restored after navigating 'back' in some browsers the
  // state of form controls is not restored until *after* the DOMContentLoaded
  // event is fired, so we need to sync after the pageshow event in browsers
  // that support it.
  if ('onpageshow' in window) {
    window.addEventListener('pageshow', function () {
      return checkboxInputs.forEach(function (input) {
        return syncAllConditionalReveals(input);
      });
    });
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      return checkboxInputs.forEach(function (input) {
        return syncAllConditionalReveals(input);
      });
    });
  }

  // Although we've set up handlers to sync state on the pageshow or
  // DOMContentLoaded event, init could be called after those events have fired,
  // for example if they are added to the page dynamically, so sync now too.
  checkboxInputs.forEach(function (input) {
    return syncAllConditionalReveals(input);
  });

  // Attach handleClick as click to checkboxInputs
  checkboxInputs.forEach(function (checkboxButton) {
    checkboxButton.addEventListener('change', handleClick);
  });
};

/***/ }),

/***/ 277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute;

/**
 * Ensure details component is cross browser and accessible
 * Test at http://localhost:3001/hse-frontend/components/details/index.html
 */

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Does the browser support details component
  var nativeSupport = typeof document.createElement('details').open === 'boolean';
  if (nativeSupport) {
    return;
  }

  // Nodelist of all details elements
  var allDetails = scope.querySelectorAll('details');

  /**
   * Adds all necessary functionality to a details element
   * @param {HTMLElement} element details element to initialise
   * @param {number} index number to be appended to dynamic IDs
   */
  var initDetails = function initDetails(element, index) {
    // Set details element as polyfilled to prevent duplicate events being added
    element.setAttribute('hse-polyfilled', 'true');

    // Give details element an ID if it doesn't already have one
    if (!element.id) element.setAttribute('id', "hse-details" + index);

    // Set content element and give it an ID if it doesn't already have one
    var content = scope.querySelector("#" + element.id + " .hse-details__text");
    if (!content.id) content.setAttribute('id', "hse-details__text" + index);

    // Set summary element
    var summary = scope.querySelector("#" + element.id + " .hse-details__summary");

    // Set initial summary aria attributes
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-controls', content.id);
    summary.setAttribute('tabIndex', '0');
    var openAttr = element.getAttribute('open') !== null;
    if (openAttr === true) {
      summary.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    } else {
      summary.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.display = 'none';
    }
    var toggleDetails = function toggleDetails() {
      toggleAttribute(summary, 'aria-expanded');
      toggleAttribute(content, 'aria-hidden');
      content.style.display = content.getAttribute('aria-hidden') === 'true' ? 'none' : '';
      if (element.hasAttribute('open')) {
        element.removeAttribute('open');
      } else {
        element.setAttribute('open', 'open');
      }
    };

    // Toggle details onclick
    summary.addEventListener('click', toggleDetails);

    // Call toggle details on enter and space key events
    summary.addEventListener('keydown', function (event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        summary.click();
      }
    });
  };

  // Initialise details for any new details element
  if (allDetails.length) {
    allDetails.forEach(function (element, index) {
      if (!element.hasAttribute('hse-polyfilled')) initDetails(element, index);
    });
  }
};

/***/ }),

/***/ 484:
/***/ (function(module) {

module.exports = function () {
  var nav = document.getElementById('header-navigation');
  var menuButton = document.getElementById('toggle-menu');
  var translationButton = document.getElementById('translations-desktop-btn');
  var searchButton = document.getElementById('toggle-search');
  var addFocus = function addFocus() {
    var navigationLinksList = nav.getElementsByClassName('hse-header-dropdown__navigation-link');
    var lastLink = navigationLinksList[navigationLinksList.length - 1];
    // eslint-disable-next-line prefer-destructuring
    var firstLink = navigationLinksList[0];
    var _document$getElements = document.getElementsByClassName('hse-header-dropdown__link'),
      logoLink = _document$getElements[0];
    if (nav.classList.contains('js-show')) {
      menuButton.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && nav.classList.contains('js-show')) {
          event.preventDefault();
          menuButton.blur();
          navigationLinksList[0].focus();
        }
        if (event.key === 'Tab' && event.shiftKey && nav.classList.contains('js-show')) {
          menuButton.blur();
          menuButton.click();
          logoLink.focus();
        }
      });
      lastLink.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && !event.shiftKey) {
          event.preventDefault();
          if (translationButton) {
            translationButton.focus();
          } else if (searchButton) {
            searchButton.focus();
          }
          if (nav.classList.contains('js-show')) {
            menuButton.click();
          }
        }
      });
      firstLink.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey) {
          event.preventDefault();
          firstLink.blur();
          menuButton.focus();
        }
      });
    }
  };
  var toggleEnter = function toggleEnter() {
    menuButton.addEventListener('keyup', function (event) {
      if (event.currentTarget.id === 'toggle-menu') {
        if (event.key === 'Enter') {
          addFocus();
        }
      }
    });
  };
  if (menuButton) toggleEnter();
};

/***/ }),

/***/ 937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var focusToggle = __webpack_require__(484);
var ToggleButtons = __webpack_require__(622);
var ToggleTranslationsMobile = __webpack_require__(754);
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var headerDropdown = scope.querySelector('.hse-header-dropdown');
  if (headerDropdown) {
    ToggleButtons('.hse-header-dropdown__');
    ToggleTranslationsMobile();
    focusToggle('.hse-header-dropdown__');
  }
};

/***/ }),

/***/ 622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute,
  toggleClass = _require.toggleClass;
module.exports = function (sltName) {
  var toggleBtns = document.querySelectorAll(sltName + "toggle-btn");
  var toggle = function toggle(button, container) {
    toggleAttribute(button, 'aria-expanded');
    toggleClass(button, 'is-active');
    toggleClass(container, 'js-show');
  };
  var toggleBtn = function toggleBtn(event) {
    event.preventDefault();
    var button = event.currentTarget;
    var controls = button.getAttribute('aria-controls');
    var container = document.getElementById(controls);
    toggleActive(button);
    toggle(button, container);
  };
  var toggleActive = function toggleActive(activeButton) {
    var activeToggleBtns = document.querySelectorAll(sltName + "toggle-btn.is-active");
    activeToggleBtns.forEach(function (button) {
      var controls = button.getAttribute('aria-controls');
      var container = document.getElementById(controls);
      if (activeButton.id !== button.id) {
        toggle(button, container);
      }
    });
  };
  var addEvents = function addEvents() {
    toggleBtns.forEach(function (elem) {
      elem.addEventListener('click', toggleBtn, false);
    });
    document.addEventListener('click', function (event) {
      var clickedElement = event.target;
      var activeToggleBtn = document.querySelector('.hse-header-dropdown__toggle-btn--translations.is-active');
      if (activeToggleBtn && clickedElement.closest(sltName + "toggle-btn") === null) {
        toggleActive(activeToggleBtn);
        var controls = activeToggleBtn.getAttribute('aria-controls');
        var container = document.getElementById(controls);
        toggle(activeToggleBtn, container);
      }
    });
  };
  if (toggleBtns) addEvents();
};

/***/ }),

/***/ 754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute,
  toggleClass = _require.toggleClass;
module.exports = function () {
  var toggleButton = document.querySelector('#toggle-translations-mobile-btn');
  var container = document.querySelector('#translations-mobile');
  var toggleSearch = function toggleSearch(event) {
    event.preventDefault();
    toggleAttribute(toggleButton, 'aria-expanded');
    toggleClass(toggleButton, 'is-active');
    toggleClass(container, 'js-show');
  };
  var addEvents = function addEvents() {
    ;
    [toggleButton].forEach(function (elem) {
      elem.addEventListener('click', toggleSearch);
    });
  };
  if (toggleButton) addEvents();
};

/***/ }),

/***/ 649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ToggleButtons = __webpack_require__(622);
module.exports = function () {
  var header = document.querySelector('.hse-header');
  if (header) {
    ToggleButtons('.hse-header__');
  }
};

/***/ }),

/***/ 13:
/***/ (function(module) {

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var notifications = scope.querySelectorAll('.hse-notification--dismissable');
  var addEvents = function addEvents() {
    notifications.forEach(function (elem) {
      var closeButton = elem.querySelector('.hse-notification__close-btn');
      closeButton.addEventListener('click', function () {
        elem.remove();
      });
    });
  };
  if (notifications) addEvents();
};

/***/ }),

/***/ 143:
/***/ (function(module) {

var REQUIRED_PRESSES = 3;
var RESET_DELAY_MS = 5000;
var LARGE_DESKTOP_BREAKPOINT = 990;
var SR_MESSAGES = ['', 'Press Shift 2 more times to hide this page', 'Press Shift 1 more time to hide this page'];
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope,
    navigate = _ref.navigate;
  var quickExits = scope.querySelectorAll('.hse-quick-exit');
  if (!quickExits.length) {
    return function () {};
  }
  var doNavigate = navigate || function (url) {
    return window.location.assign(url);
  };
  var cleanups = [];
  quickExits.forEach(function (container) {
    var exitLink = container.querySelector('.hse-button');
    var liveRegion = container.querySelector('[role="status"]');
    if (!exitLink || !liveRegion) {
      return;
    }
    var exitUrl = exitLink.getAttribute('href');
    var shiftCount = 0;
    var resetTimer = null;
    var reset = function reset() {
      shiftCount = 0;
      clearTimeout(resetTimer);
      liveRegion.textContent = '';
    };
    var handleKeyUp = function handleKeyUp(event) {
      if (!document.body.contains(container)) {
        return;
      }
      if (event.key !== 'Shift') {
        reset();
        return;
      }
      if (event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }
      clearTimeout(resetTimer);
      shiftCount += 1;
      if (shiftCount >= REQUIRED_PRESSES) {
        liveRegion.textContent = 'Leaving this page';
        shiftCount = 0;
        clearTimeout(resetTimer);
        doNavigate(exitUrl);
        return;
      }
      liveRegion.textContent = SR_MESSAGES[shiftCount];
      resetTimer = setTimeout(reset, RESET_DELAY_MS);
    };
    var handlePageShow = function handlePageShow() {
      if (!document.body.contains(container)) {
        return;
      }
      reset();
    };
    document.addEventListener('keyup', handleKeyUp);
    window.addEventListener('pageshow', handlePageShow);
    cleanups.push(function () {
      clearTimeout(resetTimer);
      document.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('pageshow', handlePageShow);
    });
  });
  var updateBodyPadding = function updateBodyPadding() {
    if (window.innerWidth >= LARGE_DESKTOP_BREAKPOINT) {
      document.body.style.removeProperty('padding-bottom');
      return;
    }
    document.body.style.paddingBottom = quickExits[0].offsetHeight + "px";
  };
  updateBodyPadding();
  window.addEventListener('resize', updateBodyPadding);
  cleanups.push(function () {
    window.removeEventListener('resize', updateBodyPadding);
    document.body.style.removeProperty('padding-bottom');
  });
  return function () {
    return cleanups.forEach(function (fn) {
      return fn();
    });
  };
};

/***/ }),

/***/ 551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleConditionalInput = _require.toggleConditionalInput;

/**
 * Conditionally show content when a radio button is checked
 * Test at http://localhost:3001/hse-frontend/components/radios/conditional.html
 */

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Radio input HTMLElements inside a conditional form group
  var radioInputs = scope.querySelectorAll('.hse-radios--conditional .hse-radios__input');

  /**
   * Update all conditional reveals to match checked state
   */
  var syncAllConditionalReveals = function syncAllConditionalReveals() {
    radioInputs.forEach(function (input) {
      return toggleConditionalInput(input, 'hse-radios__conditional--hidden');
    });
  };

  // When the page is restored after navigating 'back' in some browsers the
  // state of form controls is not restored until *after* the DOMContentLoaded
  // event is fired, so we need to sync after the pageshow event in browsers
  // that support it.
  if ('onpageshow' in window) {
    window.addEventListener('pageshow', syncAllConditionalReveals);
  } else {
    window.addEventListener('DOMContentLoaded', syncAllConditionalReveals);
  }

  // Although we've set up handlers to sync state on the pageshow or
  // DOMContentLoaded event, init could be called after those events have fired,
  // for example if they are added to the page dynamically, so sync now too.
  syncAllConditionalReveals();

  // Attach event handler to radioInputs
  radioInputs.forEach(function (radioButton) {
    radioButton.addEventListener('change', syncAllConditionalReveals);
  });
};

/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  setFocus = _require.setFocus;

/*
 * HSE.IE skip link.
 *
 * When using VoiceOver on iOS, focus remains on the skip link anchor
 * when elected so the next focusable element is not at the jumped to area.
 */

module.exports = function () {
  var $skipLink = document.querySelector('.hse-skip-link');

  // Check for skip link
  if (!$skipLink || !($skipLink instanceof HTMLAnchorElement)) {
    return;
  }
  var linkedElementId = $skipLink.hash.split('#').pop();
  var $linkedElement = linkedElementId ? document.getElementById(linkedElementId) : null;

  // Check for linked element
  if (!$linkedElement) {
    return;
  }

  /**
   * Focus the linked element on click
   *
   * Adds a helper CSS class to hide native focus styles,
   * but removes it on blur to restore native focus styles
   */
  $skipLink.addEventListener('click', function () {
    return setFocus($linkedElement, {
      onBeforeFocus: function onBeforeFocus() {
        $linkedElement.classList.add('hse-skip-link-focused-element');
      },
      onBlur: function onBlur() {
        $linkedElement.classList.remove('hse-skip-link-focused-element');
      }
    });
  });
};

/***/ }),

/***/ 969:
/***/ (function(module) {

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var allComponents = scope.querySelectorAll('.hse-step-by-step');
  if (!allComponents.length) {
    return;
  }
  var updateStepState = function updateStepState(toggle, panel, isOpen) {
    var label = toggle.querySelector('.hse-step-by-step__step-toggle-label');
    var showLabel = toggle.getAttribute('data-show-label') || 'Show';
    var hideLabel = toggle.getAttribute('data-hide-label') || 'Hide';
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    label.textContent = isOpen ? hideLabel : showLabel;
    if (isOpen) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', 'hidden');
    }
  };
  var updateGlobalState = function updateGlobalState(container) {
    var globalToggle = container.querySelector('.hse-step-by-step__toggle-all');
    var globalLabel = container.querySelector('.hse-step-by-step__toggle-all-label');
    var stepToggles = container.querySelectorAll('.hse-step-by-step__step-toggle');
    var allOpen = Array.from(stepToggles).every(function (toggle) {
      return toggle.getAttribute('aria-expanded') === 'true';
    });
    var showAllLabel = globalToggle.getAttribute('data-show-all-label') || 'Show all steps';
    var closeAllLabel = globalToggle.getAttribute('data-close-all-label') || 'Close all steps';
    globalToggle.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    globalLabel.textContent = allOpen ? closeAllLabel : showAllLabel;
  };
  var toggleAllSteps = function toggleAllSteps(container, shouldOpen) {
    container.querySelectorAll('.hse-step-by-step__step-toggle').forEach(function (toggle) {
      var panel = container.querySelector("#" + toggle.getAttribute('aria-controls'));
      updateStepState(toggle, panel, shouldOpen);
    });
    updateGlobalState(container);
  };
  allComponents.forEach(function (container) {
    var globalToggle = container.querySelector('.hse-step-by-step__toggle-all');
    var stepToggles = container.querySelectorAll('.hse-step-by-step__step-toggle');
    stepToggles.forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = container.querySelector("#" + panelId);
      var header = toggle.closest('.hse-step-by-step__step-header');
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') !== 'true';
        updateStepState(toggle, panel, isOpen);
        updateGlobalState(container);
      });
      toggle.addEventListener('focus', function () {
        var stepEl = toggle.closest('.hse-step-by-step__step');
        if (stepEl) stepEl.classList.add('hse-step-by-step__step--focused');
      });
      toggle.addEventListener('blur', function () {
        var stepEl = toggle.closest('.hse-step-by-step__step');
        if (stepEl) stepEl.classList.remove('hse-step-by-step__step--focused');
      });
      if (header) {
        header.addEventListener('click', function (e) {
          if (!toggle.contains(e.target) && e.target !== toggle) {
            toggle.click();
            toggle.focus();
          }
        });
      }
      var stepEl = toggle.closest('.hse-step-by-step__step');
      var marker = stepEl ? stepEl.querySelector('.hse-step-by-step__step-marker') : null;
      if (marker) {
        marker.addEventListener('click', function () {
          toggle.click();
          toggle.focus();
        });
      }
    });
    globalToggle.addEventListener('click', function () {
      var shouldOpen = globalToggle.getAttribute('aria-expanded') !== 'true';
      toggleAllSteps(container, shouldOpen);
    });
    updateGlobalState(container);
  });
};

/***/ }),

/***/ 265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable import/prefer-default-export */

// Components
var initCharacterCount = __webpack_require__(997);
var initCheckboxes = __webpack_require__(305);
var initDetails = __webpack_require__(277);
var initHeader = __webpack_require__(649);
var initHeaderDropdown = __webpack_require__(937);
var initNotification = __webpack_require__(13);
var initQuickExit = __webpack_require__(143);
var initRadios = __webpack_require__(551);
var initSkipLink = __webpack_require__(829);
var initStepByStep = __webpack_require__(969);
__webpack_require__(621);

/**
 * Use this function to initialise hse-frontend components within a
 * given scope. This function is called by default with the document
 * element, but you can call it again later with a new DOM element
 * containing hse-frontend components which you wish to initialise.
 *
 * @param {HTMLElement} scope
 */
function initAll(scope) {
  initCharacterCount({
    scope: scope
  });
  initCheckboxes({
    scope: scope
  });
  initDetails({
    scope: scope
  });
  initRadios({
    scope: scope
  });
  initNotification({
    scope: scope
  });
  initHeaderDropdown({
    scope: scope
  });
  initQuickExit({
    scope: scope
  });
  initStepByStep({
    scope: scope
  });
}

// Initialize components
document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initSkipLink();
  initAll(document);
});
module.exports = {
  initAll: initAll
};

/***/ }),

/***/ 621:
/***/ (function() {

/**
 * IE polyfill for NodeList.forEach()
 */
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * IE polyfill for Array.includes()
 */
if (!Array.prototype.includes) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'includes', {
    enumerable: false,
    value: function value(obj) {
      return this.filter(function (el) {
        return el === obj;
      }).length > 0;
    }
  });
}

/**
 * IE polyfill for Element.closest()
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

/**
 * IE polyfill for CustomEvent
 */
if (typeof window.CustomEvent !== 'function') {
  window.CustomEvent = function (event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(265);
/******/ 	
/******/ })()
;
